// Wraps a native `<input type="range">` in `.slider-wrap` with track + fill
// chevrons. The native input stays the source of truth - we only paint the
// fill width on `input` events. Variant `'yellow'` is used for threshold
// sliders per the design spec.

export type SliderVariant = 'violet' | 'yellow';

export function wrapRangeAsSlider(
  input: HTMLInputElement,
  variant: SliderVariant = 'violet',
): HTMLSpanElement {
  const wrap = document.createElement('span');
  wrap.className = 'slider-wrap' + (variant === 'yellow' ? ' yellow' : '');

  const track = document.createElement('span');
  track.className = 'track';
  track.setAttribute('aria-hidden', 'true');

  const fill = document.createElement('span');
  fill.className = 'fill';
  fill.setAttribute('aria-hidden', 'true');

  wrap.appendChild(track);
  wrap.appendChild(fill);
  wrap.appendChild(input);

  function paintFill(): void {
    const min = Number(input.min || '0');
    const max = Number(input.max || '100');
    const value = Number(input.value);
    const range = max - min;
    const pct = range > 0 ? ((value - min) / range) * 100 : 0;
    fill.style.width = `calc(${pct}% + 1px)`;
  }

  input.addEventListener('input', paintFill);
  // Programmatic value writes (e.g. when state syncs back into a slider)
  // dispatch `input` so this gets repainted; we still re-paint here on
  // construction to handle the initial state.
  paintFill();

  return wrap;
}
